module.exports = __webpack_public_path__ + "img/PRNT_00_mono_AE_00002.1b6051b6.png";